import React, { Component } from 'react';
import {Col, Container, Row, Stack} from "react-bootstrap";
import { ReactComponent as Arrow } from "../assets/Arrow Left.svg";


class FormStep2Feedback extends Component {


    render() {
        return (
            <Container fluid className="d-flex flex-column Form-body Peach mt-3">
                <Row style={{width: "fit-content"}} className="col-sm d-block d-sm-none">
                 <button  className="prev-button" onClick={() => {this.props.prevStep()}}><Arrow/> &nbsp; Back</button>
                </Row>
                <Row >
                    <Col>
                        <Stack className="top-row" direction="horizontal" gap={2}>
                            <div className="indicator Active"></div>
                            <div className="indicator Active"></div>
                            <div className="indicator"></div>
                        </Stack>
                    </Col>
                </Row>
                <Row className="flex-grow-1 align-items-center middle-row">
                    <Col xs={12} lg = {6} className="align-items-start">
                        <p className="text">What exactly caused your disappointment?</p>
                    </Col>
                    <Col className="align-items-center" xs={12} lg = {6}>
                        <Stack className="align-items-end">
                            <button
                                className={`form-toggle-button feedback ${this.props.inputValues.disappointmentReason === "bug" ? ' toggled bounce' : ''}`}
                                style={{justifyContent: "center"}}
                                onClick={() => {
                                    this.props.handleButtonToggle("disappointmentReason", "bug")
                                    this.props.handleButtonToggle("supportDisappointmentReason", "")
                                }}>
                                Bug in the game
                            </button>
                            <button
                                className={`form-toggle-button feedback ${this.props.inputValues.disappointmentReason === "support quality" ? ' toggled bounce' : ''}`}
                                style={{justifyContent: "center"}}
                                onClick={() => {
                                    this.props.handleButtonToggle("disappointmentReason", "support quality")
                                    this.props.handleButtonToggle("supportDisappointmentReason", "")
                                    this.props.handleTextChange("disappointmentComment", "")
                                }}>
                                Support communication quality
                            </button>
                            <button
                                className={`form-toggle-button feedback ${this.props.inputValues.disappointmentReason === "game design" ? ' toggled bounce' : ''}`}
                                style={{justifyContent: "center"}}
                                onClick={() => {
                                    this.props.handleButtonToggle("disappointmentReason", "game design")
                                    this.props.handleButtonToggle("supportDisappointmentReason", "")
                                }}>
                                Game design or feature
                            </button>
                            <button
                                className={`form-toggle-button feedback ${this.props.inputValues.disappointmentReason === "other" ? ' toggled bounce' : ''}`}
                                style={{justifyContent: "center"}}
                                onClick={() => {
                                    this.props.handleButtonToggle("disappointmentReason", "other")
                                    this.props.handleButtonToggle("supportDisappointmentReason", "")
                                    this.props.handleTextChange("disappointmentComment", "")
                                }}>
                                Other
                            </button>
                        </Stack>
                    </Col>
                </Row>
                <Row className="bottom-row align-items-center">
                    <Col className="col-sm d-none d-sm-block">
                        <button className="prev-button" onClick={() => {
                            this.props.prevStep()
                        }}>&lt; Previous Question
                        </button>
                    </Col>
                    <Col className="text-end">
                        {
                            this.props.inputValues.disappointmentReason === "" ?
                                <button className="next-button feedback disabled" disabled onClick={() => {
                                }}>Next
                                </button>:
                                <button className="next-button feedback" onClick={() => {
                                    {this.props.inputValues.disappointmentReason === "support quality" ?
                                        this.props.nextStep(8):
                                        this.props.inputValues.disappointmentReason === "other" ?
                                        this.props.nextStep(4):
                                            this.props.onSubmit(true)}
                                }}>Next
                                </button>}
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default FormStep2Feedback;